// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otpmodal-container {
    background-color: rgba(0, 0, 0, 0.2);
    height: 100%;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
    transition: opacity .15s linear;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-content{
    border: none!important;
}
.otpmodal_view {
    width: 400px;
    background-color: #fff;
    border-radius: 15px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.otpmodal_view h3 {
    font-size: 24px;
    line-height: 30.72px;
    font-family: 'Lora-Regular';
    color: #294859;
    text-align: center;
    padding-bottom: 20px;
}

.otp-input {
    width: 40px !important;
    height: 40px;
    margin: 5px;
    text-align: center;
    font-size: 20px;
    border-radius: 8px;
    border: 2px solid #ccc;
    outline: none;
}

.otpbtn {
    border: 1px solid #294859;
    padding: 8px 28px;
    border-radius: 100px;
    background-color: #294859;
    font-size: 16px;
    line-height: 18.8px;
    font-family: 'PublicSans-Regular';
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 16px;
}


@media (max-width:600px) {
    .otpmodal_view {
        width: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/OTPModal/style.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".otpmodal-container {\n    background-color: rgba(0, 0, 0, 0.2);\n    height: 100%;\n    left: 0;\n    overflow: hidden;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 999;\n    transition: opacity .15s linear;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.modal-content{\n    border: none!important;\n}\n.otpmodal_view {\n    width: 400px;\n    background-color: #fff;\n    border-radius: 15px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.otpmodal_view h3 {\n    font-size: 24px;\n    line-height: 30.72px;\n    font-family: 'Lora-Regular';\n    color: #294859;\n    text-align: center;\n    padding-bottom: 20px;\n}\n\n.otp-input {\n    width: 40px !important;\n    height: 40px;\n    margin: 5px;\n    text-align: center;\n    font-size: 20px;\n    border-radius: 8px;\n    border: 2px solid #ccc;\n    outline: none;\n}\n\n.otpbtn {\n    border: 1px solid #294859;\n    padding: 8px 28px;\n    border-radius: 100px;\n    background-color: #294859;\n    font-size: 16px;\n    line-height: 18.8px;\n    font-family: 'PublicSans-Regular';\n    color: #FFFFFF;\n    cursor: pointer;\n    margin-top: 16px;\n}\n\n\n@media (max-width:600px) {\n    .otpmodal_view {\n        width: 300px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
